module.exports = __webpack_public_path__ + "img/features03-01.f77b815.webp";